export enum ReservationSource {
	widget = 'widget',
	// TODO: Change to Dashboard
	admin = 'admin',
	google = 'google',
}
